/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  FloatButton,
  Image,
  Modal,
  Row,
  //   theme,
} from "antd";
import { MetaTags } from "react-meta-tags";
import {
  CommentOutlined,
  CloseOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { useHistory, useLocation, withRouter } from "react-router";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import "react-range-slider-input/dist/style.css";
import "./index.css";
// import moment from "moment";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadPackagesList } from "../../store/packages/actions";
import { loadCityActivitiesList } from "../../store/activities-list/actions";
import { SampleNextArrow, SamplePrevArrow } from "../../helpers/utils";
import { activityCategoriesList } from "./data";
// import { FaSearch } from "react-icons/fa";

const CityActivitiesList = (props) => {
  const dispatch = useDispatch();
  const media = useMedia();
  const history = useHistory();
  const [chatModal, setChatModal] = useState(false);
  const [categoriesSelected, setCategoriesSelected] = useState("");

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const activities = JSON.parse(params.get("activities"));
  const city = JSON.parse(params.get("cityData"));

  const activityName =
    props && props.location && props.location.state
      ? props.location.state.cityData.activityState
      : props && props.location && activities
      ? activities.packageName
      : "";
  const cityActivityName =
    props && props.location && props.location.state
      ? props.location.state.cityData.activityName
      : props && props.location && city
      ? city.activityName
      : "";
  const activitiesList =
    props && props.location && props.location.state
      ? props.location.state.cityData
      : props && props.location && city
      ? city
      : "";
  const stateActivities =
    props && props.location && props.location.state
      ? props.location.state.activities
      : props && props.location && activities
      ? activities
      : "";

  console.log(activities, "activities");
  console.log(stateActivities, "stateActivities");
  console.log(props.location, "props.location");
  const statePathName =
    props.location && props.location.pathname.replace(/\/[^/]+$/, "");

  //store integrations

  useEffect(() => {
    dispatch(loadPackagesList("?destinationIds=" + activitiesList.cityId));
    dispatch(loadCityActivitiesList("?cityId=" + activitiesList.cityId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { packages_list = [] } = useSelector((state) => state.Packages);
  const { city_activities_list = [] } = useSelector(
    (state) => state.Activities
  );

  const slides =
    packages_list &&
    packages_list.datum &&
    packages_list.datum.packageList.length > 0
      ? packages_list.datum.packageList.map((data) => {
          return {
            destinationId: data.destinationId,
            itineraries: data.itineraries,
            days:
              data.itineraries.length > 0
                ? data.itineraries.length + " Days"
                : 0,
            nights:
              data.itineraries.length > 0
                ? parseFloat(data.itineraries.length - 1) + " Nights"
                : 0,
            startingFrom: data.lowestPrice
              ? "₹ " + parseFloat(data.lowestPrice + 2000)
              : "",
            imgHeight: 250,
            Price: data.lowestPrice !== null ? "₹ " + data.lowestPrice : "₹ 0",
            packageCategoryId: data.packageCategoryId,
            packageCode: data.packageCode,
            hotels: data.packageIncludes ? data.packageIncludes.hotels : false,
            meals: data.packageIncludes ? data.packageIncludes.meals : false,
            transport: data.packageIncludes
              ? data.packageIncludes.transport
              : false,
            sightSeeing: data.packageIncludes
              ? data.packageIncludes.sightSeeing
              : false,
            packageName: data.packageName,
            imageUrl:
              data.thumbnailsImages && data.thumbnailsImages.length > 0
                ? data.thumbnailsImages[0].imageUrl
                : "",
            Duration: data.tourPlan,
            _id: data._id,
          };
        })
      : [];
  const sliderRef = useRef(null);
  const [slideWidth, setSlideWidth] = useState(0);

  const getSlideWidth = () => {
    if (sliderRef.current) {
      const slickTrack =
        sliderRef.current.innerSlider.list.querySelector(".slick-track");
      const slickSlide = slickTrack?.querySelector(".slick-slide");
      if (slickSlide) {
        const width = slickSlide.getBoundingClientRect().width;
        setSlideWidth(width);
      }
    }
  };
  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    ref: sliderRef,
    onInit: getSlideWidth, // <-- this triggers on load
    onReInit: getSlideWidth, // <-- also when resized or re-rendered
    afterChange: getSlideWidth, // <-- after sliding
    centerPadding: "3px",
    slidesToShow:
      media == "xxl" && slides && slides.length >= 6
        ? 6
        : media == "xxl" && slides && slides.length <= 4
        ? slides.length
        : media == "xl" && slides && slides.length >= 5
        ? 5
        : media == "xl" && slides && slides.length <= 4
        ? slides.length
        : media == "lg" && slides && slides.length >= 4
        ? 4
        : media == "lg" && slides && slides.length <= 4
        ? slides.length
        : media == "md" && slides && slides.length >= 3
        ? 3
        : media == "md" && slides && slides.length <= 4
        ? slides.length
        : media == "sm" && slides && slides.length >= 3
        ? 2
        : media == "sm" && slides && slides.length < 4
        ? slides.length
        : 1,
    // fade: true,
    // speed: 1200,
    // autoplay: true,
    // autoplaySpeed: 2200,
    nextArrow: <SampleNextArrow marginRight="15px" />,
    prevArrow: <SamplePrevArrow marginLeft="15px" />,
    // nextArrow: <SampleNextArrow slides={slides} marginRight="15px" />,
    // prevArrow: <SamplePrevArrow slides={slides} marginLeft="15px" />,
    // slidesToScroll: 1,
    // cssEase: "linear",
  };

  const cityData =
    city_activities_list &&
    city_activities_list.data &&
    city_activities_list.data;

  const activityCategories =
    cityData && cityData.areaCategory.length > 0
      ? cityData.areaCategory.map((data) => {
          const iconData =
            data.categoryname !== undefined
              ? activityCategoriesList.find(
                  (activity) => activity.label === data.categoryname
                )
              : "";
          return {
            label: data.categoryname,
            count: data.count,
            _id: data._id,
            icon: iconData !== undefined ? iconData.icon : "",
          };
        })
      : [];
  const imageUrl =
    cityData &&
    cityData.cityDetails &&
    cityData.cityDetails.images &&
    cityData.cityDetails.images.length > 0
      ? cityData.cityDetails.images[0].imageUrl
      : activitiesList &&
        activitiesList !== undefined &&
        activitiesList.imageUrl !== undefined
      ? activitiesList.imageUrl
      : "";
  const cityActivitiesList =
    city_activities_list &&
    city_activities_list.data &&
    city_activities_list.data.cities.length > 0
      ? city_activities_list.data.cities.map((data) => {
          return {
            activityName: data.areaName,
            imageUrl:
              data.image && data.image.length > 0 ? data.image[0].imageUrl : "",
            // activityCity: "Kochi",
            // activityState: "Kerala",
            destinationId: data.destinationId,
            cityId: cityData.cityDetails ? cityData.cityDetails._id : "",
            areaId: data.areaId,
            lowestPrice: data.lowestPrice,
            // activityName: data.cityName,
            noOfActivities: data.noOfActivities,
            activityCity:
              cityData && cityData.cityDetails
                ? cityData.cityDetails.destinationName
                : "",
            activityState:
              stateActivities && stateActivities
                ? stateActivities.packageName
                : "",

            // imageUrl: data.images && imageUrl !== "" ? imageUrl : "",
          };
        })
      : [];

  // const currentYear = moment().format("YYYY");
  const temp = document.createElement("div");

  temp.innerHTML =
    cityData && cityData.cityDetails !== undefined
      ? cityData.cityDetails.description
      : "";

  const description = temp.textContent || temp.innerText || "";
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>
            Best Places to visit in {"" + cityActivityName} | Plan mi trip
          </title>
        </MetaTags>
      </div>
      <Col
        md={24}
        sm={24}
        lg={24}
        xl={24}
        xxl={24}
        className="mr-[-6px] mt-[-20px]"
      >
        <Row
          className={
            media == "sm"
              ? "pr-[6%] pl-[6%] "
              : media == "xs"
              ? "pl-[30px]"
              : media == "md"
              ? "pr-[7%] pl-[7%]"
              : media == "lg"
              ? "pr-[10%] pl-[10%]"
              : media == "xxl"
              ? "pr-[11%] pl-[11%]"
              : "pr-[6.5%] pl-[6.5%]"
          }
        >
          <Col
            sm={24}
            xs={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media === "md" || media === "sm" || media === "xs"
                ? "mt-7 flex justify-between"
                : media === "lg"
                ? "mt-[70px] flex justify-between"
                : "mt-4 flex justify-between"
            }
          >
            <div className="flex">
              <Link
                to={{
                  pathname: "/",
                }}
                className="input-label font-semibold text-[#2b2a2a73] hover:bg-[lightgray] px-1 rounded-md hover:text-[black] text-[11px]"
              >
                Home
              </Link>
              <p className="mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <Link
                to={{
                  pathname: "/destinations",
                }}
                className="input-label font-semibold text-[#2b2a2a73] hover:bg-[lightgray] px-1 rounded-md hover:text-[black] text-[11px]"
              >
                Destinations
              </Link>
              <p className="mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <Link
                to={{
                  pathname: statePathName,
                  state: stateActivities,
                }}
                className="input-label font-semibold text-[#2b2a2a73] hover:bg-[lightgray] px-1 rounded-md hover:text-[black] text-[11px]"
              >
                {activityName}
              </Link>
              <p className="mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <p className="input-label font-semibold text-[#eb3e43] px-1 text-[11px]">
                {cityActivityName}
              </p>
              <p className=" mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <p className="input-label font-semibold text-[#eb3e43] px-1 text-[11px]">
                {"Places to Visit in " + cityActivityName}
              </p>
            </div>
            <div
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
              }}
            >
              BEST Things to Do in {cityActivityName}, India
            </div>
          </Col>
          <Col
            sm={24}
            xs={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className="mt-2"
          >
            <Row>
              <Col sm={24} xs={24} md={12} lg={12} xl={12} xxl={12}>
                <div className="w-[100%] mt-5 pl-1 h-[388px]">
                  <Image
                    src={imageUrl ? imageUrl : ""}
                    preview={false}
                    width={"105%"}
                    height={388}
                    className="border border-1 rounded-2xl"
                  />
                </div>
              </Col>
              <Col
                sm={24}
                xs={24}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="mt-[15px]"
              >
                <div className="w-[100%] text-start pl-[90px] pr-8">
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-black text-[34px]"
                  >
                    {cityActivityName}
                    {/* {"Places to Visit in " + cityActivityName} */}
                  </h1>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-normal text-[18px]"
                  >
                    {"Check out must-see sights and destinations:"}
                  </h1>

                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-normal text-[13px] mt-2"
                  >
                    {cityData && cityData.cityDetails ? description : ""}
                  </h1>
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            sm={24}
            xs={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className="mt-[40px] pb-[50px] border border-b-1 border-t-0 border-x-0"
          >
            <div className="w-[100%] text-start pr-8">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="font-black text-[24px] mb-2"
              >
                {"Explore popular experiences"}
              </h1>
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="font-normal text-[14px]"
              >
                {
                  "See what other travellers like to do, based on ratings and number of bookings."
                }
              </h1>
            </div>
            <Row
              style={{
                fontFamily: "Poppins",
              }}
              className="w-[100%] mt-5"
            >
              {activityCategories.map((data, index) => {
                // const gridWidth =
                //   data.label === "Safaris" || data.label === "Mountains"
                //     ? 4
                //     : 5;
                return (
                  <Col
                    // sm={24}
                    // xs={24}
                    // md={gridWidth}
                    // lg={gridWidth}
                    // xl={gridWidth}
                    // xxl={gridWidth}
                    key={index}
                    className="pr-3 mb-3"
                  >
                    <div
                      className={
                        categoriesSelected === data.label
                          ? "bg-[#efefef] relative cursor-pointer flex justify-between border border-black pl-4 pr-2 pt-2 pb-2"
                          : "bg-[white] relative cursor-pointer flex justify-between border border-1 pl-4 pr-2 pt-2 pb-2"
                      }
                      onClick={() => {
                        setCategoriesSelected(data.label);
                        dispatch(
                          loadCityActivitiesList(
                            `?cityId=${activitiesList.cityId}&categoryId=${data._id}`
                          )
                        );
                      }}
                      style={{
                        borderRadius: "10px",
                      }}
                    >
                      <div className="flex">
                        <p className="mt-[1px] mr-1 ">{data.icon}</p>
                        <h1
                          style={{
                            display: "inline-block",
                            width: "max-content",
                          }}
                          className="input-label text-[12px] font-semibold"
                        >
                          {data.label}({data.count})
                        </h1>
                      </div>
                    </div>
                    {categoriesSelected === data.label ? (
                      <CloseCircleOutlined
                        onClick={() => {
                          setCategoriesSelected("");
                          dispatch(
                            loadCityActivitiesList(
                              `?cityId=${activitiesList.cityId}`
                            )
                          );
                        }}
                        className="absolute top-[-4px] right-[8px]"
                      />
                    ) : (
                      ""
                    )}
                  </Col>
                );
              })}
            </Row>
          </Col>
          <Col
            sm={24}
            xs={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className="mt-[40px]  border border-b-1 border-t-0 border-x-0 pb-8"
          >
            <div className="w-[100%] text-start pr-8">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="font-black text-[20px] mb-2"
              >
                {`Popular Areas in ${cityActivityName}`}
              </h1>
            </div>
            <Row
              style={{
                fontFamily: "Poppins",
              }}
              className="w-[100%] mt-5 flex flex-row"
            >
              {cityActivitiesList.map((data, index) => {
                return (
                  <Col
                    md={12}
                    lg={6}
                    xl={6}
                    xxl={6}
                    sm={24}
                    xs={24}
                    className={
                      media !== "md" || media !== "sm" || media !== "xs"
                        ? "pr-5 pb-3 cursor-pointer"
                        : index == 5
                        ? "pr-5 pb-3 cursor-pointer"
                        : "pr-5 pb-3 cursor-pointer"
                    }
                    // onClick={() =>
                    //   history.push({
                    //     pathname: `/activities/activity-in-${data.packageName}`,
                    //     state: data,
                    //   })
                    // }
                  >
                    <Link
                      to={`/destinations/destination-in-${activityName}/${
                        data.activityCity
                      }/Places to Visit in ${data.activityCity}/${
                        data.activityName
                      }?activities=${encodeURIComponent(
                        JSON.stringify(stateActivities)
                      )}&cityList=${encodeURIComponent(
                        JSON.stringify(activitiesList)
                      )}&area=${encodeURIComponent(JSON.stringify(data))}`}
                      target="_blank"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                          // border: "1px solid rgba(200, 203, 206, 0.81)",
                        }}
                        className="group h-[280px] relative rounded-2xl overflow-hidden shadow-lg cursor-pointer"
                        key={index}
                      >
                        <Image
                          //   src={data.imageUrl}
                          src={data.imageUrl}
                          preview={false}
                          height={280}
                          width={"100%"}
                          className="w-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-10 group-hover:bg-opacity-50 transition-colors duration-300"></div>
                        <div className="absolute top-20 left-7 right-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="flex items-center justify-between">
                            <div className="text-white">
                              <p className="text-sm">Discover</p>
                              <p className="text-sm">Destinations In</p>
                              <h2 className="text-lg font-semibold">
                                {data.activityName}
                              </h2>
                            </div>
                            <div className="bg-[#eb3e43] text-white w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300">
                              →
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="mt-3 font-semibold"
                      >
                        <div className="text-[16px] group-hover:opacity-0 transition-opacity font-semibold">
                          {data.activityName}
                        </div>
                        <div className="text-[13px] group-hover:opacity-0 transition-opacity font-normal">
                          {data.activityState + ", India"}
                        </div>
                      </div>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          </Col>
          <Col
            sm={24}
            xs={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className="mt-[40px] border border-b-1 border-t-0 border-x-0 pb-8"
          >
            <div className="w-[100%] text-start pr-8">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="font-black text-[20px] mb-2"
              >
                {`Recommended for You in ${cityActivityName}`}
              </h1>
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="font-normal text-[14px] mb-2"
              >
                {"Tours and destinations tailored to your interests."}
              </h1>
            </div>
            <div
              style={{
                fontFamily: "Poppins",
              }}
              className="mt-5"
            >
              {slides && slides.length < 4 ? (
                slides.map((slide, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        history.push({
                          pathname: `/package-details/${slide._id}`,
                          state: slide,
                        });
                      }}
                      className="cursor-pointer h-[260px] pr-2 pl-2"
                    >
                      <Image
                        preview={false}
                        alt="no-img"
                        src={slide.imageUrl}
                        width={
                          // slides.length === 1 &&
                          // (media === "md" ||
                          //   media === "sm" ||
                          //   media === "xs" ||
                          //   media === "lg"
                          //   )
                          //   ? "67%"
                          media === "md"
                            ? "27%"
                            : media === "sm" || media === "xs"
                            ? "27%"
                            : "24%"
                        }
                        className="border border-solid cursor-pointer relative rounded-md"
                        height={270}
                      />
                      {/* <div className="cursor-pointer w-[70%] absolute rounded-tl-2xl rounded-bl-2xl inset-0 bg-[lightgray] bg-opacity-5 h-[250px] hover:bg-opacity-15 transition-colors duration-300"></div> */}
                      <div className="w-[100%] z-10">
                        <p
                          style={{
                            position: "absolute",
                            top: "80px",
                            bottom: "20px",
                            color: "#ffffff",
                            width:
                              // slides.length === 1 &&
                              // (media === "lg" ||
                              //   media === "xl" ||
                              //   media === "xxl")
                              //   ? "24%"
                              //   : slides.length === 1 &&
                              //     (media === "md" ||
                              //       media === "sm" ||
                              //       media === "xs")
                              //   ? "36%"
                              //   :
                              media === "md"
                                ? "26%"
                                : media === "sm" || media === "xs"
                                ? "26.5%"
                                : "23.5%",
                            background: "#0000002b",
                            fontSize: "18px",
                            fontFamily: "Poppins",
                            fontWeight: 700,
                            padding: "20px",
                            borderRadius: "8px",
                          }}
                        >
                          {slide.packageName}
                        </p>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "10px",
                            marginLeft: "1px",
                            color: "#f1f1f1ed",
                            fontSize: "14px",
                            fontWeight: 700,
                            zIndex: 20,
                            padding: "20px 20px",
                          }}
                        >
                          <h1
                            style={{
                              display: "flex",
                              flexDirection:
                                media == "lg" ||
                                media == "md" ||
                                media == "sm" ||
                                media == "xs"
                                  ? "column"
                                  : "row",
                            }}
                          >
                            <p
                              style={{
                                fontFamily: "Poppins",
                              }}
                            >
                              Starting at
                            </p>
                            <p className="flex ml-2">
                              <p
                                className=""
                                style={{
                                  // fontFamily: "Poppins",
                                  fontWeight: 800,
                                  fontSize: "14px",
                                  marginTop: "2px",
                                }}
                              >
                                {slide.Price}
                              </p>
                            </p>
                          </h1>
                          <div
                            style={{
                              fontFamily: "Poppins",
                              marginTop: "-2px",
                            }}
                          >
                            Per Person
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : slides && slides.length > 3 ? (
                <Slider {...settings} centerMode className="h-[100%]">
                  {slides.map((slide, index) => {
                    return (
                      <div
                        key={index}
                        onClick={() => {
                          history.push({
                            pathname: `/package-details/${slide._id}`,
                            state: slide,
                          });
                        }}
                        className="cursor-pointer h-[250px] pr-2 pl-2"
                      >
                        <Image
                          preview={false}
                          alt="no-img"
                          src={slide.imageUrl}
                          width={"100%"}
                          className="border border-solid cursor-pointer relative rounded-md"
                          height={slide.imgHeight}
                        />
                        {/* <div className="cursor-pointer w-[70%] absolute rounded-tl-2xl rounded-bl-2xl inset-0 bg-[lightgray] bg-opacity-5 h-[250px] hover:bg-opacity-15 transition-colors duration-300"></div> */}
                        <div className="w-[100%] z-10">
                          <p
                            style={{
                              position: "absolute",
                              top: "0px",
                              bottom: "5px",
                              color: "#ffffff",
                              width: slideWidth && parseFloat(slideWidth - 18),
                              background: "#0000002b",
                              fontSize: "18px",
                              fontFamily: "Poppins",
                              fontWeight: 700,
                              padding: "20px",
                              borderRadius: "8px",
                            }}
                          >
                            {slide.packageName}
                          </p>
                          <div
                            style={{
                              position: "absolute",
                              bottom: "5px",
                              marginLeft: "1px",
                              color: "#f1f1f1ed",
                              fontSize: "14px",
                              fontWeight: 700,
                              zIndex: 20,
                              padding: "20px 20px",
                            }}
                          >
                            <h1
                              style={{
                                display: "flex",
                                flexDirection:
                                  media == "lg" ||
                                  media == "md" ||
                                  media == "sm" ||
                                  media == "xs"
                                    ? "column"
                                    : "row",
                              }}
                            >
                              <p
                                style={{
                                  fontFamily: "Poppins",
                                }}
                              >
                                Starting at
                              </p>
                              <p className="flex ml-2">
                                <p
                                  className=""
                                  style={{
                                    // fontFamily: "Poppins",
                                    fontWeight: 800,
                                    fontSize: "14px",
                                    marginTop: "2px",
                                  }}
                                >
                                  {slide.Price}
                                </p>
                              </p>
                            </h1>
                            <div
                              style={{
                                fontFamily: "Poppins",
                                marginTop: "-2px",
                              }}
                            >
                              Per Person
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              ) : (
                <div className="text-center images-label">
                  No Packages found
                </div>
              )}
            </div>
          </Col>
        </Row>

        <Modal
          open={chatModal}
          title=""
          maskClosable={false}
          onClose={() => setChatModal(false)}
          closable
          footer={null}
          closeIcon={
            <CloseOutlined
              onClick={() => setChatModal(false)}
              className="text-[#ffffff]"
            />
          }
          width={600}
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={12}
                  sm={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="p-3"
                >
                  <h2 className="text-[#ffffff]">
                    Don't miss out on our exclusive deals & insider only offers!
                  </h2>
                  <div className="text-[#ffffff] mt-2">
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      5 years of Experience in India
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Packages across 50 + Countries
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Best Travel Partner of India
                    </div>
                  </div>
                </Col>
                <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
              </Row>
            </div>
          </Col>
        </Modal>
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-7px",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        />
      </Col>
    </React.Fragment>
  );
};

CityActivitiesList.propTypes = {
  location: PropTypes.any,
};

export default withRouter(CityActivitiesList);
